function initializeLazyVideos(document, window) {
    const videos = document.querySelectorAll('iframe[data-kd-video-src]');
    if (!videos.length) return;

    function load(video) {
        if (!video.hasAttribute('src')) {
            video.setAttribute('src', video.dataset.kdVideoSrc);
        }
    }

    if (typeof window.IntersectionObserver !== 'function') {
        videos.forEach(load);
        return;
    }

    const observer = new window.IntersectionObserver(entries => {
        entries.forEach(entry => {
            // Shared/private descriptions contain duplicate embeds; only load
            // the one with a layout box, including when a hidden section opens.
            if (!entry.isIntersecting || !entry.target.getClientRects().length) return;
            load(entry.target);
            observer.unobserve(entry.target);
        });
    }, { rootMargin: '300px 0px', threshold: 0 });
    videos.forEach(video => observer.observe(video));
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initializeLazyVideos(document, window), { once: true });
    } else {
        initializeLazyVideos(document, window);
    }
}
module.exports = { initializeLazyVideos };
